import { render, staticRenderFns } from "./quick-details.vue?vue&type=template&id=646d32b4&scoped=true"
import script from "./quick-details.vue?vue&type=script&lang=ts"
export * from "./quick-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646d32b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\WebDev\\Source\\PeppermillReno.com\\[DEV]\\[WEB] PeppermillReno.com DEV\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('646d32b4')) {
      api.createRecord('646d32b4', component.options)
    } else {
      api.reload('646d32b4', component.options)
    }
    module.hot.accept("./quick-details.vue?vue&type=template&id=646d32b4&scoped=true", function () {
      api.rerender('646d32b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "library/js/components/view-room-details/quick-details.vue"
export default component.exports